import React, { useState, useEffect } from 'react';
import sessionManager from '../utils/sessionManager';

const SessionTimeoutWarning = ({ isOpen, onStayLoggedIn, onLogout }) => {
  const [remainingTime, setRemainingTime] = useState('');
  const [warningTime, setWarningTime] = useState(5 * 60); // 5 minutes in seconds

  useEffect(() => {
    if (!isOpen) return;

    // Update countdown every second
    const interval = setInterval(() => {
      if (warningTime > 0) {
        setWarningTime(prev => prev - 1);
        const minutes = Math.floor(warningTime / 60);
        const seconds = warningTime % 60;
        setRemainingTime(`${minutes}:${seconds.toString().padStart(2, '0')}`);
      } else {
        // Time's up, auto-logout
        onLogout();
      }
    }, 1000);

    // Initial time display
    const minutes = Math.floor(warningTime / 60);
    const seconds = warningTime % 60;
    setRemainingTime(`${minutes}:${seconds.toString().padStart(2, '0')}`);

    return () => clearInterval(interval);
  }, [isOpen, warningTime, onLogout]);

  const handleStayLoggedIn = () => {
    sessionManager.extendSession();
    setWarningTime(5 * 60); // Reset warning time
    onStayLoggedIn();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
        <div className="flex items-center mb-4">
          <div className="flex-shrink-0">
            <svg className="w-8 h-8 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 18.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-lg font-medium text-gray-900">Session Timeout Warning</h3>
          </div>
        </div>
        
        <div className="mb-4">
          <p className="text-sm text-gray-600">
            You have been inactive for a while. Your session will automatically expire in:
          </p>
          <div className="mt-2 text-center">
            <span className="text-2xl font-bold text-red-600">{remainingTime}</span>
          </div>
          <p className="text-sm text-gray-600 mt-2">
            You will be automatically logged out for security reasons.
          </p>
        </div>
        
        <div className="flex space-x-3">
          <button
            onClick={handleStayLoggedIn}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Stay Logged In
          </button>
          <button
            onClick={onLogout}
            className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-700 font-medium py-2 px-4 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            Logout Now
          </button>
        </div>
        
        <div className="mt-3 text-center">
          <p className="text-xs text-gray-500">
            This helps protect your account from unauthorized access.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutWarning; 